// Default benefits array
export const defaultBenefits = [
  "Start learning a new skill today.",
  "Learn on your phone, tablet, or computer.",
  "Add a certificate to your resume and LinkedIn.",
  "Grow both personally and professionally.",
];
